class BeforeUnload {
	constructor() {
		this.dirty = false;
	}

	_warning = (e) => {
		const msg = 'Er du sikker på du vil forlade siden uden at gemme?';
		e.returnValue = msg;
		return msg;
	}

	set = () => {
		if (! this.dirty) {
			this.dirty = true;
			window.addEventListener('beforeunload', this._warning);
		}
	}

	clear = () => {
		this.dirty = false;
		window.removeEventListener('beforeunload', this._warning);
	}
}

module.exports = new BeforeUnload;



// WEBPACK FOOTER //
// ./resources/js/helpers/BeforeUnload.js